import { useEffect } from 'react'
import type { NoraVoiceState } from '@src/screens/Nora/hooks/useNoraVoice'
import { NoraAudioPlayback } from '@src/screens/Nora/native/NoraAudioPlayback'

export const NoraVoicePlayer = ({
  currentAudioPath,
  onPlaybackEnd,
  onPlaybackError,
}: NoraVoiceState) => {
  useEffect(() => {
    if (!currentAudioPath) {
      return
    }

    let active = true
    let errorReported = false
    const reportPlaybackError = (error: Error) => {
      if (!active || errorReported) {
        return
      }

      errorReported = true
      onPlaybackError(error)
    }

    void NoraAudioPlayback.play(currentAudioPath, {
      onEnd: () => {
        if (!active) {
          return
        }

        onPlaybackEnd()
      },
      onError: reportPlaybackError,
    }).catch((error) => {
      const message = error instanceof Error ? error.message : String(error)
      reportPlaybackError(new Error(message))
    })

    return () => {
      active = false
      void NoraAudioPlayback.stop().catch(() => undefined)
    }
  }, [currentAudioPath, onPlaybackEnd, onPlaybackError])

  return null
}
